import { render, staticRenderFns } from "./CalculationsForm.vue?vue&type=template&id=2ac50d85&scoped=true&"
import script from "./CalculationsForm.vue?vue&type=script&lang=js&"
export * from "./CalculationsForm.vue?vue&type=script&lang=js&"
import style0 from "./CalculationsForm.vue?vue&type=style&index=0&id=2ac50d85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac50d85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VForm,VProgressCircular,VSelect,VSpacer,VTextField,VTextarea})
